module.exports = __webpack_public_path__ + "img/main-component-1.cd8712a7.svg";